import { defineStore } from 'pinia';
import { type Cart, type CartItem } from '~/dto/cart';

export const useCartStore = defineStore('cart', () => {
  const loaded = ref(false);
  const showShippingDialog = ref(false);
  const cart = ref<Cart>();
  const cartItems = ref<CartItem[]>([]);
  const shipping = ref<{ countryCode: string | null, city: string | null, zipCode: string | null }>({
    countryCode: "FR",
    city: null,
    zipCode: null,
  });
  const cartId = computed(() => cart.value?.id);

  return {
    loaded,
    cart,
    cartItems,
    shipping,
    showShippingDialog,
    cartId,
  };
}, {
  persist: {
    pick: ['cart', 'shipping'],
  }
});
